<script lang="ts" setup>
// Composables
import { useRouter } from 'vue-router'
import type School from '@/core/domain/school/core/School.ts'
import CBaseCard from '@/presentation/components/base/CBaseCard.vue'
import { useSchoolStore } from '@/presentation/stores/school/school.ts'

const router = useRouter()

const props = defineProps<{
  school: School
}>()

const { selectSchool } = useSchoolStore()

const showSchool = () => {
  selectSchool(props.school)
  router.push({
    name: 'school',
    params: {
      schoolSlug: props.school.slug
    }
  })
}
</script>

<template>
  <c-base-card :title="school.name" has-footer>
    <template #content>
      <div class="flex w-full flex-col gap-2">
        <p>
          {{ school.address ?? 'Adresse non renseignée' }}<br />
          {{ school.zipCode ?? 'Non spécifié' }} {{ school.city ?? 'Non spécifié' }} ({{
            school.department ?? 'Non spécifié'
          }})
        </p>

        <p class="flex items-center gap-2">
          <i class="pi pi-home text-gray-500"></i>
          <span>Académie : {{ school.schoolDistrict ?? 'Non spécifié' }}</span>
        </p>
      </div>
    </template>

    <template #footer>
      <div class="mt-2 flex w-full justify-end">
        <button
          class="text-primary-500 cursor-pointer transition-colors duration-200 hover:text-blue-700 focus:outline-none"
          @click="showSchool"
        >
          Afficher l'établissement
        </button>
      </div>
    </template>
  </c-base-card>
</template>
